'use client'

/**
 * PostHog User Identification Component
 * PostHog is initialized via instrumentation-client.js
 * This component only handles user identification
 */

import { useEffect } from 'react'
import { identifyUser } from '@/lib/posthog-client'
import { useCurrentUser } from '@/hooks/use-current-user'

export function PostHogInit() {
  const { user } = useCurrentUser()

  // Identify user when logged in
  useEffect(() => {
    if (user?._id) {
      identifyUser(user._id.toString(), {
        email: user.email,
        name: user.name,
        account_type: user.account_type,
        coin: user.coin,
        last_login_time: user.last_login_time,
      })
    }
  }, [user])

  return null // This component doesn't render anything
}
